import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardActions,
  Grid,
  Button,
} from "@mui/material";
import "./MembershipCertificate.scss";
import { UploadCertificateService } from "services/menu/uploadCertificate/UploadCertificateService";
import { RequestModel } from "model/utilModels/RequestModel";
import { msgTypes } from "constants/msgTypes";
import ApiUrl from "services/shared/ApiUrl";
import PdfViewer from "../pdfViewer/PdfViewer";
import { LocalStorageService } from "services/auth/LocalStorageService";
import { ResponseModel } from "model/utilModels/ResponseModel";

function MembershipCertificate({ companyId, selfProfile }) {
  // const [certificate, setCertificate] = useState([])
  const [imageUrl, setImageUrl] = useState("")
  const [pdfUrl, setPdfUrl] = useState("")
  // const [downloadFlag, setDownloadFlag] = useState(true);


  useEffect(() => {
    if(companyId!=='' && companyId!==undefined){
    loadData()
    }
  }, [companyId])

  const loadData = async () => {
    await getUserDetails()
  }

  const staticImageUrl = "/images/no-certification.jpg";

  const getUserDetails = async () => {
    const requestBody = new RequestModel();
    requestBody.companyId = companyId;
    let res=new ResponseModel();
    if(companyId!=='' && companyId!==undefined){
      res = await UploadCertificateService.getListByCompanyId(requestBody)
    }
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        const certificateDetails = res.data[0];
        // setCertificate(certificateDetails)
        if (certificateDetails.image !== "") {
          const imageUrl = ApiUrl.fileBaseUrl + certificateDetails.image;
          setImageUrl(imageUrl)
          const pdfUrl = ApiUrl.fileBaseUrl + certificateDetails.pdf;
          setPdfUrl(pdfUrl)
        }else {
          setImageUrl(staticImageUrl);
        }
      }else {
        setImageUrl(staticImageUrl);
      }
    } else {
      setImageUrl(staticImageUrl);
    }
  }

  const handleDownloadPDF = () => {
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "MembershipCertificate.pdf"; // specify the filename
    document.body.appendChild(link);
    link.setAttribute('target', '_blank')
    link.click();
    document.body.removeChild(link);
  };


  return (
    <>

      <Box className="certificate-main-box mt-0">
        <Grid container className=" certificate-main-grid ">
          <Card variant="outlined" className="card border-0 certificate-Card h-100 pt-0">
            <Grid>
              {/* <Badge
                badgeContent={4}
                color="warning"
                className="mermbership-certificate-badge"
              > */}

              <Card
                variant="outlined"
                className="certificate-image-card w-100 pt-0 "

              >
                {/* <div className="bell-icon">
                  <NotificationsIcon color="primary" />
                </div> */}

                {/* <CardHeader title="Download Certificate"></CardHeader> */}
                <div className="main-card-flow px-3">
                  <div className="card-overflow-hidden h-100 mt-3">

                    <h6 className="certificate-heading">Membership Certificate</h6>




                    {/* <embed src={certificateUrl} type="application/pdf" className="pdf-edit" /> */}


                    <div>
                    <img src={imageUrl} alt="certificate image"   />
                      {/* {imageUrl !== staticImageUrl ? (
                        // <PdfViewer pdfUrl={certificateUrl}/>
                        <img src={imageUrl} alt="certificate image"   />
                      ) : (
                        <img src={staticImageUrl} alt="No PDF available" />
                      )} */}
                    </div>
                    {/* <button className="btn btn-primary w-100" onClick={handleDownloadPDF}>
                        Download pdf
                      </button> */}

                    {/* <object width="200" height="200" data="http://192.168.1.30:8081/media/certificate/simple1.pdf" type="application/pdf"></object> */}
                    {/* <iframe src="{certificateUrl}" className="pdf-edit" /> */}

                    {/* <CardMedia
                    className="certificate-image"
                    component="img"
                    alt="Certificate"
                    image="https://apps.aoi.wsu.edu/onlineMedia/pdf_version/hort102_20_art(c131).pdf"
                  /> */}
                  </div>
                </div>
              </Card>
              <CardActions>
                {/* <FormikControl
                  className="download-certificate-button"
                  control="button"
                  color="primary"
                  label="Download"
                  fullWidth
                /> */}
                {selfProfile && (
                  <Button
                    variant="contained"
                    className="btn btn-certi"
                    onClick={handleDownloadPDF}
                    // onClick={downloadFile}
                    sx={{ mt: 2, backgroundColor: "#F29E2F", width: "100%" }}
                    disabled={imageUrl === staticImageUrl}
                  >
                    Download
                  </Button>
                )}
              </CardActions>
            </Grid>
          </Card>
        </Grid>
      </Box>












    </>
  );
}

export default MembershipCertificate;
